import { render, staticRenderFns } from "./map-order.vue?vue&type=template&id=2f670b18&scoped=true&"
import script from "./map-order.vue?vue&type=script&lang=js&"
export * from "./map-order.vue?vue&type=script&lang=js&"
import style0 from "./map-order.vue?vue&type=style&index=0&id=2f670b18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f670b18",
  null
  
)

export default component.exports